// extracted by mini-css-extract-plugin
export var header = "_gf-0";